import { addDays } from 'date-fns';

import {
  BUS_SEARCH_FORM_SET_ORIGIN,
  BUS_SEARCH_FORM_SET_DESTINATION,
  BUS_SEARCH_FORM_SET_DEPARTURE_DATE,
} from '../actions/BusBookingSearchFormAction';
import { SET_BOOK_ON_BEHALF } from '../actions/setBookOnBehalf';
import { SET_AGENT_ID } from '../actions/setAgentId';
import { LOGOUT_ACTION } from 'modules/general/shared/action/logout';
import { SET_RESCHEDULE_ON_BEHALF_AGENT_ID } from '../actions/setRescheduleOnBehalfAgentId';

const initialState = {
  origin: {},
  destination: {},
  departureDate: addDays(new Date(), 2),
  bookOnBehalf: false,
  agentId: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case BUS_SEARCH_FORM_SET_ORIGIN:
      return {
        ...state,
        origin: action.payload,
      };
    case BUS_SEARCH_FORM_SET_DESTINATION:
      return {
        ...state,
        destination: action.payload,
      };
    case BUS_SEARCH_FORM_SET_DEPARTURE_DATE:
      return {
        ...state,
        departureDate: action.payload,
      };
    case SET_BOOK_ON_BEHALF:
      return { ...state, bookOnBehalf: action.bookOnBehalf };
    case SET_AGENT_ID:
      return { ...state, agentId: action.agentId };
    case SET_RESCHEDULE_ON_BEHALF_AGENT_ID:
      return { ...state, agentId: action.agentId, bookOnBehalf: true };
    case LOGOUT_ACTION:
      return initialState;
    default:
      return state;
  }
}
